import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { buildElectricalSignatureData } from './electrical-signature.utils';

@Component({
  selector: 'app-vehicle-fingerprint-electrical-signature',
  templateUrl: './electrical-signature.component.html',
  styleUrls: ['./electrical-signature.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintElectricalSignatureComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  dayCount = 0;
  chartContext: ChartContext = {
    type: 'line',
    title: 'امضای الکتریکی',
    showTitle: false,
    data: [],
    colors: ['#ffc16c'],
    unit: 'V',
    theme: 'dark',
  };

  ngOnChanges(): void {
    const data = buildElectricalSignatureData(this.context);
    this.dayCount = data.length;
    this.chartContext = { ...this.chartContext, data };
  }
}
